export default "__VITE_ASSET__470339e0__"